import { useState } from 'react';
import PropTypes from 'prop-types';
import { FIELD_CLASS, FIELD_LABEL_CLASS } from '../../../../../component/common/StandardUI';
import ChecklistCheckbox, { CHECKBOX_CLASS } from './ChecklistCheckbox';
import addCircleIcon from '../../../../../assets/svg/icons/Add-Circle--Streamline-Flex.svg';
import subtractCircleIcon from '../../../../../assets/svg/icons/Subtract-Circle--Streamline-Flex.svg';

const rowInputClass = FIELD_CLASS;

const ChecklistEditor = ({ items, onChange, error }) => {
  const [newSubtaskText, setNewSubtaskText] = useState('');

  const handleTextChange = (index, text) => {
    const next = [...items];
    next[index] = { ...next[index], text };
    onChange(next);
  };

  const handleToggle = (index) => {
    const next = [...items];
    next[index] = { ...next[index], isCompleted: !next[index].isCompleted };
    onChange(next);
  };

  const handleRemove = (index) => {
    onChange(items.filter((_, i) => i !== index));
  };

  const handleInsertAfter = (index) => {
    const next = [...items];
    next.splice(index + 1, 0, { text: '', isCompleted: false });
    onChange(next);
  };

  const commitNewSubtask = () => {
    const trimmed = newSubtaskText.trim();
    if (!trimmed) return;
    onChange([...items, { text: trimmed, isCompleted: false }]);
    setNewSubtaskText('');
  };

  return (
    <div>
      <label className={`${FIELD_LABEL_CLASS} mb-2`}>Checklist</label>
      <div className="space-y-2">
        {items.map((item, index) => (
          <div key={index} className="flex items-center gap-2">
            <ChecklistCheckbox
              checked={!!item.isCompleted}
              onToggle={() => handleToggle(index)}
              label={`Mark checklist item ${index + 1} complete`}
            />
            <input
              type="text"
              value={item.text}
              onChange={(e) => handleTextChange(index, e.target.value)}
              placeholder={`Checklist item ${index + 1}`}
              className={`${rowInputClass} flex-1`}
            />
            <button
              type="button"
              onClick={() => handleInsertAfter(index)}
              aria-label="Add item"
              className="hover:opacity-70 transition-opacity"
            >
              <img src={addCircleIcon} alt="" className="w-6 h-6 shrink-0 dark:invert" />
            </button>
            <button
              type="button"
              onClick={() => handleRemove(index)}
              aria-label="Remove item"
              className="hover:opacity-70 transition-opacity"
            >
              <img src={subtractCircleIcon} alt="" className="w-6 h-6 shrink-0 dark:invert" />
            </button>
          </div>
        ))}

        <div className="flex items-center gap-2">
          <span className={`${CHECKBOX_CLASS} bg-white dark:bg-shoorah-darkBgColor opacity-60`} />
          <input
            type="text"
            value={newSubtaskText}
            onChange={(e) => setNewSubtaskText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                commitNewSubtask();
              }
            }}
            onBlur={commitNewSubtask}
            placeholder="New subtask..."
            className={`${rowInputClass} flex-1`}
          />
          <button
            type="button"
            onClick={commitNewSubtask}
            aria-label="Add subtask"
            className="hover:opacity-70 transition-opacity"
          >
            <img src={addCircleIcon} alt="" className="w-6 h-6 shrink-0 dark:invert" />
          </button>
          <img
            src={subtractCircleIcon}
            alt=""
            className="w-6 h-6 shrink-0 opacity-40 dark:invert"
          />
        </div>
      </div>
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

ChecklistEditor.propTypes = {
  items: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
};

export default ChecklistEditor;
